import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

interface ResolvePromptProps {
  onYes: () => void;
  onNo: () => void;
}

// Системный prompt «Вопрос решён?» с кнопками Да/Нет.
// Показывать/скрывать решает родитель (ChatWindow) — этот компонент только рендерит UI.
export const ResolvePrompt: React.FC<ResolvePromptProps> = ({ onYes, onNo }) => {
  return (
    <Box sx={{ px: 2, py: 1 }}>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
        Вопрос решён?
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        <Chip
          label="Да"
          color="success"
          size="small"
          onClick={onYes}
          sx={{ cursor: 'pointer' }}
        />
        <Chip
          label="Нет"
          color="default"
          variant="outlined"
          size="small"
          onClick={onNo}
          sx={{ cursor: 'pointer' }}
        />
      </Box>
    </Box>
  );
};
